'use client';

import { useState } from 'react';

export default function Home() {
  const [target, setTarget] = useState('http://satellite-1.stark.local');
  const [output, setOutput] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePing = async () => {
    setLoading(true);
    setOutput('Initiating connection...');
    try {
      const res = await fetch(`/api/ping?server=${encodeURIComponent(target)}`);
      const data = await res.json();
      if (data.success) {
        setOutput(`[${data.statusLine}]\n${data.responseText}`);
      } else {
        setOutput(`[ERROR] ${data.error}`);
      }
    } catch {
      setOutput('[ERROR] Network failure.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-black text-cyan-400 font-mono p-8 selection:bg-cyan-900">
      <div className="max-w-2xl mx-auto border border-cyan-800 p-8 shadow-[0_0_15px_rgba(0,255,255,0.2)] bg-[#000a12] rounded-lg">
        <header className="mb-8 border-b border-cyan-900 pb-4">
          <h1 className="text-4xl font-black tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600">
            E.D.I.T.H.
          </h1>
          <div style={{ display: 'none' }} aria-hidden="true">
            {/* Decoy Token */ "SPIDEY{th1s_is_jU5t_4_h0l0gr4ph1c_f4k3}"}
          </div>
          <p className="text-xs uppercase tracking-[0.3em] text-cyan-600 mt-2">
            Even Dead, I&apos;m The Hero &mdash; Global Security Network
          </p>
        </header>

        <section className="space-y-6">
          <div className="space-y-2">
            <label className="uppercase text-xs flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-cyan-500 animate-pulse"></span>
              Ping External Satellite Node
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                value={target}
                onChange={(e) => setTarget(e.target.value)}
                className="flex-1 bg-[#001424] border border-cyan-800 p-3 outline-none focus:border-cyan-400 text-cyan-100"
              />
              <button
                onClick={handlePing}
                disabled={loading}
                className="bg-cyan-800/50 hover:bg-cyan-600 border border-cyan-400 px-6 uppercase font-bold tracking-widest transition-all disabled:opacity-50"
              >
                Execute
              </button>
            </div>
            <p className="text-[10px] text-cyan-700">
              * Local interfaces (e.g. localhost, 127.0.0.1) and /api/admin-override are restricted by network topology.
            </p>
          </div>

          <div className="bg-[#00050a] border border-cyan-900 h-64 p-4 rounded overflow-auto text-sm text-cyan-200 shadow-inner">
            <pre className="whitespace-pre-wrap">{output || '> Awaiting command...'}</pre>
          </div>
        </section>
      </div>
    </main>
  );
}
